import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppContext } from '../../AppModulesWrapper';
import { selectMicrofrontendInitLoadTime } from '../../Microfrontend';
import { getPerfomanceNowTimeSec } from '../utils';

export const useAppLoadTelemetryTime = () => {
  const { isMicrofrontend } = useAppContext();

  const microfrontendInitLoadTime = useSelector(selectMicrofrontendInitLoadTime);

  const getAppLoadTimeTelemetry = useCallback(() => {
    if (isMicrofrontend) {
      return Number((getPerfomanceNowTimeSec() - microfrontendInitLoadTime).toFixed(2));
    }

    // Подробнее про перформанс тайминги тут
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
    return Number(((Date.now() - performance.timeOrigin) / 1000).toFixed(2));
  }, [isMicrofrontend, microfrontendInitLoadTime]);

  return { getAppLoadTimeTelemetry };
};
